import { createAction } from '../../../store.model';
import { ActionType } from '../main.action';

export interface ToggleFilterCategory {
    categoryId: number;
}

export const toggleFilterCategory = createAction<
    ActionType,
    ToggleFilterCategory
>(ActionType.MI2_MAIN__TOGGLE_FILTER_CATEGORY);
